var Logger = /** @class */ (function () {
    function Logger() {
    }
    return Logger;
}());
export { Logger };
//# sourceMappingURL=Logger.js.map